export default {
  ID: 'ESIGN_FAIL_STEP',
  BG_WHITE: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
};
